import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useState } from "react";
import TableWallet from "../../walletReports/table";
import CardBoxLayout from "@/modules/user/layout/cardBoxLayout";
import { useQuery } from "@tanstack/react-query";
import { fetchCreditPurchases } from "@/api/user/home";
import { numberSeparator,toPersianNumber } from "@/hooks/useThousandsSeparator";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import moment from "jalali-moment";
import { useNavigate } from "react-router";
import ContentSkeleton from "../../walletReports/content.skeleton";

const Content = () => {
  const [loanID] = useState(1); // Removed setLoanID if not used elsewhere

  const { data, isLoading, error } = useQuery({
    queryKey: ["storePoint-data", loanID],
    queryFn: () => fetchCreditPurchases(loanID),
  });

  const dataHeader = [
    { id: "totalPayed", title: "نام فروشگاه" },
    { id: "ts", title: "تاریخ صدور" },
    { id: "amount", title: "مبلغ امتیاز( ریال)" },
    { id: "sumPayment", title: "زمان استفاده" },
    { id: "clearingAmount", title: "آدرس پذیرنده" },
  ];

  const navigate = useNavigate();

  // Safely transform the data
  const newDataStorePont = data?.data 
    ? Array.isArray(data.data) 
      ? data.data.map((item: any) => {
          return {
            ...item,
            totalPayed: numberSeparator(`${item?.data?.totalPayed || ""}`),
            ts: toPersianNumber(moment(item.data?.ts || new Date()).locale("fa").format("YYYY/MM/DD")),
            amount: numberSeparator(item.amount || "0"),
            sumPayment: numberSeparator(`${item.data?.installments?.[0]?.sum || ""}`),
            clearingAmount: item.data?.clearingAmount || "",
            start: moment(item?.start || new Date()).locale("fa").format("YYYY-MM-DD"),
            end: moment(item?.end || new Date()).locale("fa").format("YYYY-MM-DD"),
            details: item.details || "",
            detailButton: (
              <StackKit 
                justifyContent={"center"} 
                alignItems={"center"} 
                sx={{
                  background:"linear-gradient(147.72deg, #272727 -17.1%, #333333 118.66%)",
                  borderRadius: "50%",
                  height: "30px",
                  width: "30px",
                }} 
                onClick={() => navigate(`/credits/${item.id}`)}
              >
                <NorthWestIcon style={{ color: "#fff", width: "15px", cursor: "pointer" }}/>
              </StackKit>
            ),
          };
        })
      : [] // Return empty array if data.data exists but isn't an array
    : []; // Return empty array if data or data.data is undefined

  // Use the transformed data directly instead of renaming to fakeData
  const displayData = newDataStorePont;

  return (
    <CardBoxLayout sx={{padding: '1rem'}}>
      <StackKit alignItems={"start"} justifyContent={"start"}>
        <TypoGraphyKit variant="body1">
          لیست پذیرنده هایی که میتوانید اعتبارات هدیه خود را در آن ها استفاده
          نماید به شرح ذیل میباشد
        </TypoGraphyKit>
        {isLoading ? (
          <ContentSkeleton />
        ) : error ? (
          <TypoGraphyKit variant="body2" color="error">
            خطا در بارگذاری داده‌ها
          </TypoGraphyKit>
        ) : displayData.length === 0 ? (
          <TypoGraphyKit variant="body2">
            داده‌ای برای نمایش وجود ندارد
          </TypoGraphyKit>
        ) : (
          <TableWallet dataHeader={dataHeader} dataTbody={displayData} />
        )}
      </StackKit>
    </CardBoxLayout>
  );
};

export default Content;